import { Button, Form } from 'react-bootstrap';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';
import spinnerTitle from 'components/others/spinnerTitle';
import { useEffect, useRef } from 'react';
import type { WarehouseNameMode } from './model';
import SolarIcon from 'components/icons/SolarIcon';

interface WarehouseNameFormProps {
    mode: WarehouseNameMode;
    label: string;
    inputId: string;
    handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
    isSubmitting: boolean;
    error?: string;
    autofocus?: boolean;
}

const WarehouseNameForm = ({
    mode,
    label,
    inputId,
    handleSubmit,
    isSubmitting,
    error,
    autofocus = true,
}: WarehouseNameFormProps) => {
    const { t } = useTranslation(['common']);
    const refInput = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (!autofocus) return;
        setTimeout(() => refInput.current?.focus(), 100);
    }, [autofocus]);

    const isCreate = mode === 'create';

    return (
        <Form className="d-flex flex-column h-100" onSubmit={handleSubmit}>
            <div className="off-create-team-form d-flex flex-column h-100">
                <div className="off-create-team-content px-3">
                    <Form.Group className="mb-3">
                        <label className="form-label text-muted" htmlFor={inputId}>
                            {label}
                        </label>
                        <Field
                            innerRef={refInput}
                            required
                            id={inputId}
                            name="name"
                            className={`form-control ${error ? 'is-invalid' : ''}`}
                            autoFocus={autofocus}
                        />
                        {error ? <div className="invalid-feedback d-block">{error}</div> : null}
                    </Form.Group>
                </div>

                <div className="p-3 offcanvas-footer off-create-team-footer">
                    <div className="d-flex justify-content-end">
                        <Button type="submit" variant="info" disabled={isSubmitting} className="min100px">
                            {spinnerTitle(
                                <>
                                    <SolarIcon name="check2-all" className="fs-14 me-2" />
                                    {isCreate ? t('common:buttons.create') : t('common:buttons.save')}
                                </>,
                                isSubmitting,
                                isCreate ? t('common:buttons.creating') : t('common:buttons.saving'),
                            )}
                        </Button>
                    </div>
                </div>
            </div>
        </Form>
    );
};

export default WarehouseNameForm;
